import axios from "axios";
import {
  IAddUser,
  IAddUserRequestBody,
  IAuth,
  IEditUserRequestBody,
  ILoginRequestBody,
  IResetCustomerPassword,
} from "../slice/user.model";
import { TOKEN_LOCAL_KEY } from "../../Config/constants";
import { isValidString } from "../../Utils/validators";

const BASE_URL = "http://216.38.6.193:3001"; //process.env.REACT_APP_API_HOST;
export class Login {
  private static _instance: Login;

  private constructor() {}

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  async addUser(body: IAddUserRequestBody) {
    const response = await axios.post<IAddUser>(
      `${BASE_URL}/api/auth/signup`,
      body
    );

    return response;
  }

  async loginUser(body: ILoginRequestBody) {
    const response = await axios.post<IAuth>(`${BASE_URL}/api/auth/signin`, {
      username: body.username,
      password: body.password,
    });

    if (isValidString(response.data.data.token)) {
      this.saveTokenToSession(response.data.data.token);
    }

    return response;
  }

  saveTokenToSession(accessToken: string) {
    try {
      //   const encodedStr = this.encryptTokens(
      //     accessToken,
      //     refreshToken,
      //     tokenType
      //   );
      window.localStorage.setItem(TOKEN_LOCAL_KEY, accessToken);
    } catch (ex) {
      console.log(ex);
    }
  }

  removeUserFromSession() {
    window.localStorage.removeItem(TOKEN_LOCAL_KEY);
  }

  async listUser() {
    const response = await axios.get(`${BASE_URL}/api/auth/list`);

    return response;
  }

  async editUser(body: IEditUserRequestBody) {
    const response = await axios.put<IAddUser>(
      `${BASE_URL}/api/auth/updateuser`,
      body
    );

    return response;
  }

  async resetCustomerPassword(body: IResetCustomerPassword) {
    const response = await axios.put<IAddUser>(
      `${BASE_URL}/api/auth/resetPassword`,
      body
    );

    return response;
  }

  async deleteUser(user_id: string) {
    const response = await axios.delete<IAddUser>(
      `${BASE_URL}/api/auth/deleteUser/${user_id}`
    );

    return response;
  }
}
